import { createColumnHelper } from "@tanstack/react-table";
import { useMemo } from "react";
import useBulkSelectColumnDefinition from "components/common/EntityDataTable/hooks/useBulkSelectColumnDefinition";
import { BULK_SELECT_COL_ID, ACTIONS_COL_ID } from "components/common/EntityDataTable/Constants";
import useActionsColumnDefinition from "components/common/EntityDataTable/hooks/useActionsColumnDefinition";
import useAttributeColumnDefinitions from "components/common/EntityDataTable/hooks/useAttributeColumnDefinitions";
const useColumnDefinitions = ({
  actionsColMinWidth,
  columnRenderersByAttribute,
  columnSchemas,
  columnWidths,
  displayBulkSelectCol,
  entityActions,
  entityAttributesAreCamelCase,
  hasRowActions,
  meta,
  onActionsWidthChange,
  onHeaderSectionResize,
  parentBgColor
}) => {
  const columnHelper = createColumnHelper();
  const bulkSelectCol = useBulkSelectColumnDefinition(displayBulkSelectCol, columnWidths[BULK_SELECT_COL_ID]);
  const actionsCol = useActionsColumnDefinition({
    colWidth: columnWidths[ACTIONS_COL_ID],
    minWidth: actionsColMinWidth,
    entityActions,
    hasRowActions,
    onWidthChange: onActionsWidthChange,
    parentBgColor
  });
  const attributeCols = useAttributeColumnDefinitions({
    columnSchemas,
    columnRenderersByAttribute,
    columnWidths,
    entityAttributesAreCamelCase,
    meta,
    columnHelper,
    onHeaderSectionResize
  });
  return useMemo(
    () => [...bulkSelectCol ? [bulkSelectCol] : [], ...attributeCols, ...actionsCol ? [actionsCol] : []],
    [bulkSelectCol, attributeCols, actionsCol]
  );
};
export default useColumnDefinitions;
